import type { OptionDefinition } from "../types.ts";
import { cameraGeneralOptions } from "./camera-general.ts";
import { cameraControlOptions } from "./camera-controls.ts";
import { phoneOptions } from "./phone.ts";
import { microphoneOptions } from "./microphone.ts";
import { advancedOptions } from "./advanced.ts";

/** All option definitions combined, in display order */
export const allOptionDefinitions: OptionDefinition[] = [
  ...cameraGeneralOptions,
  ...cameraControlOptions,
  ...phoneOptions,
  ...microphoneOptions,
  ...advancedOptions,
];
